export const mutations = {
  STORE_DESTINATIONS(state, destinations) {
    state.destinations = destinations;
  },
  STORE_DESTINATION_UPDATE(state, destinationId) {
    let Destination = state.destinations.find(function(destinations) {
      return destinations.id === destinationId;
    });
    state.systemDestination = Destination;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/destinations/mutations.js